import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { ENVIRONMENT } from 'src/configs/environment/environment';

import { appConfig } from '../app-config';
import { AppComponent } from '../app.component';

export async function initApp(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (ENVIRONMENT.production) {
      enableProdMode();
    }

    bootstrapApplication(AppComponent, appConfig)
      .then(() => {
        resolve();
      })
      .catch(reject);
  });
}
